/**
 * Returns whether the visual refresh mode is currently enabled.
 *
 * The visual refresh is the default. It is only turned off when
 * `globalThis.dtVisualRefreshEnabled` is explicitly set to `false`; any other
 * value — including leaving it unset — keeps the refresh enabled.
 * @internal
 */
export function isVisualRefreshEnabled(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  // oxlint-disable-next-line typescript/no-explicit-any
  return (globalThis as any).dtVisualRefreshEnabled !== false;
}
